// 普通课程
// import { get, post, url } from '../../service/ApiDecorator'

import { get, url, post, postJson } from '../../service/ApiDecorator'

class CourseNormal {
  // 查询列表（卡控用户权限）
  @url('/v3/itemData/listReportDataAppGroup')
  @get
  listReportDataAppGroup() {}

  // 获取用户查询结果（过程数据）
  @url('/v3/dataapp/getProcessDataResultForCondition')
  @post
  getProcessDataResultForCondition() {}
  // 移动端获取 数据应用 用户查询条件
  @url('/app/dataapp/v4/getDataAppCondition')
  @get
  getDataAppCondition() {}
  // 普通实践课-添加课程活动
  @url('/v3/normalpractice/add')
  @postJson
  addNormalPractice() {}
  // 通过提交数据ID查询对应的任务
  @url('/v3/normalpractice/getByFormValueId')
  @get
  getByFormValueId() {}
  // 普通实践课-获取活动名称
  @url('/v3/normalpractice/listActiveNameByCourseNameAndCode')
  @get
  listActiveNameByCourseNameAndCode() {}
  // 普通实践课-获取课程名称
  @url('/v3/normalpractice/listCourseNameByCourseCode')
  @get
  listCourseNameByCourseCode() {}
  // 普通实践课-我要报名，生成数据应用
  @url('/v3/normalpractice/addBySignUp')
  @postJson
  addBySignUp() {}
  // 普通实践课-获取学生提交列表
  @url('/v3/normalpractice/listSignUpVo')
  @get
  listSignUpVo() {}
  // 课程活动删除校验
  @url('/v3/normalpractice/deleteCheck')
  @get
  deleteCheck() {}
  // 普通实践课-学生退选
  @url('/v3/normalpractice/delSignUpVo')
  @get
  delSignUpVo() {}
  // 普通实践课-删除活动
  @url('/app/dataapp/deleteOneFormValueAndTaskByApp')
  @get
  deleteOneFormValueAndTaskByApp() {}
  // 获取普通实践课设置的分数
  @url('/v3/api/synth/query/getCourseScore')
  @get
  getCourseScore() {}
  // 获取课程列表
  @url('/v3/api/query/course/listCourseSubjectOption')
  @get
  listCourseSubjectOption() {}
  // 自主实践课-课程列表
  @url('/v3/Autonomy/getSynthAutonomyhCoursePage')
  @post
  getSynthAutonomyhCoursePage() {}
  // 自主实践课-我的申请记录-得分明细
  @url('/v3/Autonomy/getScoreDetail')
  @get
  getScoreDetail() {}
  // 社团活动-通过社团id获取数据应用id
  @url('/v3/syntheticalAssociation/getSaasAssociationToDataAppMap')
  @get
  getSaasAssociationToDataAppMap() {}
  // 自主实践课新建查询课程是否唯一
  @url('/v3/synth/checkSingleCourse')
  @get
  checkSingleCourse() {}
  // 查询课程分数
  @url('/center/api/course/getInfoById')
  @get
  getInfoById() {}
}

export default new CourseNormal()
